/**
 * NewsItemView view component.
 * @module components/theme/View/NewsItemView
 */

import { Grid } from 'semantic-ui-react';
import { UniversalLink, FormattedDate, Image } from '@plone/volto/components';
import { hasBlocksData, BodyClass, flattenToAppURL } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { isEmpty } from 'lodash';
import { Attachments, ShareBar } from '../';


const NewsItemView = ({ content }) => {

  const newsLink = content.parent?.['@id'] ? flattenToAppURL(content.parent['@id']) : '';

  return (
    <>
      <BodyClass className='smallHeader' />

      <Grid>
        <Grid.Row columns={12}>
          <Grid.Column mobile={12} tablet={12} computer={7} widescreen={8} largeScreen={8}>

            {hasBlocksData(content) && (
              <div className="docRenderBlocks">
                <RenderBlocks content={content} />
              </div>
            )}

          </Grid.Column>
          <Grid.Column mobile={12} tablet={12} computer={5} widescreen={4} largeScreen={4}>

            {content.preview_image && (
              <figure className="newsitem-view__figure m-0">
                <Image
                  className="w-100 h-auto"
                  item={content}
                  imageField="preview_image"
                  alt=''
                  sizes="100vw"
                />
                {content.preview_caption && (
                  <figcaption className='newsitem-view__figure__caption'>{content.preview_caption}</figcaption>
                )}
              </figure>
            )}

          </Grid.Column>
        </Grid.Row>
      </Grid>

      <div className="border-top pt-4 mt-5 d-flex border-gray-bg">

        {!isEmpty(content.subjects) && (
          <aside className="">              
            <ul className="list-unstyled my-0 ms-0 me-3">
              {content.subjects.map((item) => (
                <li className='pe-2' key={item} >
                  <UniversalLink 
                    href={`${newsLink}?category=${encodeURIComponent(item)}`} 
                    className="subjectLabel"
                  >
                    {item}
                  </UniversalLink>

                </li>
              ))}
            </ul>
          </aside>
        )}

        <time dateTime={content.effective} className='d-flex ms-auto align-items-center'>
          <FontAwesomeIcon icon={faCalendar} />
          <FormattedDate date={content.effective} className="ms-2"
            format={{
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }}
          />
        </time>
      </div>

      <Attachments {...content} />
      <ShareBar />
    </>
  );

};


export default NewsItemView;
